export type ConstituentComplaintComment = {
  id: number;
  constituent_complaint_id: number;
  user_id: number;
  parent_id: number | null;
  author_name: string;
  body: string;
  created_at: string;
};

const jsonHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

function csrfToken(): string {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") ?? "";
}

function commentsPath(municipalityId: number, complaintId: number): string {
  return `/api/v1/municipalities/${municipalityId}/trust_complaints/${complaintId}/comments`;
}

export async function listConstituentComplaintComments(
  municipalityId: number,
  complaintId: number,
): Promise<ConstituentComplaintComment[]> {
  const response = await fetch(commentsPath(municipalityId, complaintId), {
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  if (!response.ok) throw new Error("Failed to load comments");
  return response.json();
}

export async function createConstituentComplaintComment(
  municipalityId: number,
  complaintId: number,
  body: string,
  parentId?: number,
): Promise<ConstituentComplaintComment> {
  const response = await fetch(commentsPath(municipalityId, complaintId), {
    method: "POST",
    credentials: "include",
    headers: { ...jsonHeaders, "X-CSRF-Token": csrfToken() },
    body: JSON.stringify({
      constituent_complaint_comment: { body, parent_id: parentId ?? null },
    }),
  });
  if (!response.ok) throw new Error("Failed to create comment");
  return response.json();
}
